import { combineReducers } from 'redux'
import dataReducer from 'lib/reducers/dataReducer'
import requestStateReducer from 'lib/reducers/requestStateReducer'
import { orderedProductTypes } from 'actions/types'

const initialState = null
const baseType = orderedProductTypes.FETCH_ORDERED_PRODUCT

const reducer = combineReducers({
  data: dataReducer({ initialState, baseType }),
  requestState: requestStateReducer(baseType),
})

export default reducer
